import React, { useContext, useEffect } from "react";
import Slider from "react-slick";
import { QuestionMarkIcon } from "~/assets/svg/InterfaceIcon";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { SolidCloseIcon } from "~/assets/svg/CloseIcon";
import { AppManContext } from "../../../RoundManContext";
import { Trans, useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";

const settings = {
	arrows: true,
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: 7,
	slidesToScroll: 1,
};

const ProcessTwo = ({ processStep, setProcessStep }) => {
	const { t } = useTranslation();
	const { judgeList, setJudgeList, setResultProcessTwo, modiData } = useContext(AppManContext);
	const attendFilter = judgeList.filter((d) => d.role !== "") || [];

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	useEffect(() => {
		if (modiData) {
			const tempJudge = modiData.judge;
			const itemJudge = tempJudge.map((d) => ({ userIdx: d.userIdx, role: d.role }));
			const newData = judgeList.map((d) => {
				const target = itemJudge.find((c) => c.userIdx === d.userIdx);
				if (target) {
					return { ...d, role: target.role };
				} else {
					return d;
				}
			});
			setJudgeList(newData);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modiData]);

	const toggleJudgeRole = (userIdx, idx) => {
		const choose = judgeList.find((d) => d.userIdx === userIdx);
		if (attendFilter.length === 10 && choose.role === "") {
			alert(t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.alert"));
			return;
		}
		let newData;
		if (idx === 0 || idx === "0") {
			newData = judgeList.map((d) =>
				d.userIdx === userIdx
					? {
							...d,
							role:
								d.role === "심사참여"
									? "심사관망"
									: d.role === "심사관망"
									? "심사참여"
									: "심사참여",
					  }
					: d
			);
		} else {
			newData = judgeList.map((d) =>
				d.userIdx === userIdx
					? {
							...d,
							role:
								d.role === ""
									? "심사참여"
									: d.role === "심사참여"
									? "심사관망"
									: d.role === "심사관망"
									? ""
									: "",
					  }
					: d
			);
		}
		setJudgeList(newData);
	};

	const handleRemoveJudge = (userIdx) => {
		const removeData = judgeList.map((d) => (d.userIdx === userIdx ? { ...d, role: "" } : d));
		setJudgeList(removeData);
	};

	const nextStepValidation = () => {
		setResultProcessTwo(attendFilter);
		setProcessStep(processStep + 1);
	};
	// () => setProcessStep(processStep + 1)

	return (
		<>
			<div className="modal-content judgeSetup">
				<div className="setup-header">
					<div className="title-wrap">
						<p className="desc">
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.titleDesc"
							)}
						</p>
						<div className="c__tooltip-btn">
							<QuestionMarkIcon />
							<span className="c__tooltip">
								<div className="tooltip-title">
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.tooltip.title"
									)}
								</div>
								<div className="help-content">
									<p>
										<Trans
											i18nKey="pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.tooltip.content1"
											components={[<b />]}
										/>
									</p>
									<p>
										<Trans
											i18nKey="pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.tooltip.content2"
											components={[<b />]}
										/>
									</p>
									<p>
										<Trans
											i18nKey="pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.tooltip.content3"
											components={[<b />]}
										/>
									</p>
								</div>
							</span>
						</div>
					</div>
				</div>
				<div className="c__card setup-card">
					<Slider {...settings} className="vc-carousel">
						{judgeList.map((d, idx) => {
							return (
								<div
									className="participant"
									key={d.userIdx}
									onClick={() => toggleJudgeRole(d.userIdx, idx)}
								>
									<div
										className={`img-wrap ${
											d.role === "심사참여"
												? "attend"
												: d.role === "심사관망"
												? "watching"
												: null
										}`}
									>
										<img
											src={
												d.img ||
												(theme === "dark"
													? DarkDefaultProfileImg
													: LightDefaultProfileImg)
											}
											alt={t(
												"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.imageAlt"
											)}
										/>
									</div>
									<h5 className={"participant-info"}>
										{d.name}{" "}
										{idx === 0 &&
											t(
												"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.info"
											)}
									</h5>
								</div>
							);
						})}
					</Slider>
					<div className="participant-list-wrap">
						<p className="participant-num">
							<Trans
								i18nKey="pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.participant"
								components={[<b />, { attendFilter }]}
							/>
						</p>
						<div className="scroll-wrap">
							<ul className="participant-list">
								{attendFilter.map((d, idx) =>
									idx === 0 ? (
										<li key={idx}>
											{d.name +
												`(${d.role === "심사참여" ? "참여" : "관망"})`}
										</li>
									) : (
										<li key={idx}>
											{d.name +
												`(${d.role === "심사참여" ? "참여" : "관망"})`}
											<button
												type="button"
												onClick={() => handleRemoveJudge(d.userIdx, idx)}
											>
												<SolidCloseIcon />
											</button>
										</li>
									)
								)}
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="gray"
					disabled={processStep === 0}
					onClick={() => setProcessStep(processStep - 1)}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.prev")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={nextStepValidation}
					// onClick={showConfirmAlert}
					// onClick={showExternalAlert}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessTwo.next")}
				</button>
			</div>
		</>
	);
};

export default ProcessTwo;
